export const stoppagesSchema = {
    "$schema": "http://json-schema.org/draft-07/schema#",
    "$id": "StoppagesSchema",
    "title": "Stoppages Schema",
    "type": "object",
    "properties": {
        "id": {
            "$id": "#/properties/id",
            "type": "number"
        },
        "start_time": {
            "$id": "#/properties/start_time",
            "type": "string",
            "format": "custom-date-time"
        },
        "end_time": {
            "$id": "#/properties/end_time",
            "type": "string",
            "format": "custom-date-time"
        },
        "reason": {
            "$id": "#/properties/reason",
            "type": "string"
        },
        "isbreak": {
            "$id": "#/properties/isbreak",
            "type": ["boolean", "string"]
        }
    },
    "errorMessage": {
        "properties": {
            "id": "Value for 'id' should be a number",
            "start_time": "Value for 'start_time' should be a Date in format 'DD/MM/YYYY hh:mm:ss' or 'YYYY-MM-DDThh:mm:ss.SSSZ'",
            "end_time": "Value for 'end_time' should be a Date in format 'DD/MM/YYYY hh:mm:ss' or 'YYYY-MM-DDThh:mm:ss.SSSZ'",
            "reason": "Value for 'reason' should be a String",
            "isbreak": "Value for 'isbreak' should be a boolean",
        },
    },
    "additionalProperties": true,
}